import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { isEmpty, size } from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import * as moment from "moment";
import toast, { Toaster } from "react-hot-toast";
const { SearchBar, ClearSearchButton } = Search;
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Badge,
  ModalHeader,
  ModalBody,
  Label,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

//Import Actions
import {getTestsListRequest, getTestsListSuccess, getTestsListFail} from "../../store/tests/actions"
import { updateTestRequest, updateTestSuccess, updateTestFail, deleteTestRequest } from "../../store/tests/actions";

import DeleteModal from "components/Common/DeleteModal";
const MySearchBar = prop => {
  console.log(JSON.stringify(prop))
  let input;
  const handleClick = () => {
    prop.onSearch(input.value);
  };

  return (
    <div className="app-search">
      <div className="position-relative">
        <input
          type="text"
          className="form-control bg-white border border-3 shadow w-100"
          placeholder={"TestsListSearch" + "..."}
          ref={ n => input = n }
          onChange={handleClick}
        />
        <span className="bx bx-search-alt"></span>
      </div>
    </div>
  );
};
class TestsList extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      viewmodal: false,
      modal: false,
    
    tests: [],
      order: "",
      test: "",
      deleteModal: false,
      TestListColumns: [
     
        {
          dataField: "id",
          text: "Test ID",
          sort: true,
          hidden: true,
          formatter: (cellContent, row) => (
            <Link to="#" className="text-body fw-bold">
              {row.id}
            </Link>
          ),
        },
        {
            dataField: "Title",
            text: "Test Title",
            sort: true,
          },
          {
            dataField: "LowerPriceLimit",
            text: "Lower Price Limit",
            sort: true,
          },
          {
            dataField: "UpperPriceLimit",
            text: "Upper Price Limit",
            sort: true,
          },
          {
            dataField: "AvgDuration",
            text: "Duration",
            sort: true,
          },
        {
          dataField: "view",
          isDummyField: true,
          text: "View Details",
          sort: true,
          formatter: (cellContent, row) => (
            console.log({ pathname: `/TestOverview/${row.id}` }),
            (
              <Link
                to={{ pathname: `/TestOverview/${row.id}` }}
                className="btn btn-primary btn-sm btn-rounded"
              >
                View Details
              </Link>
            )
          ),
        },
        
        {
          dataField: "action",
          isDummyField: true,
          text: "Action",
          formatter: (cellContent,test) => (
            <>
              <div className="d-flex gap-3">
                <Link to="#" className="text-success">
                  <i
                    className="mdi mdi-pencil font-size-18"
                    id="edittooltip"
                    onClick={() => this.handleEditClick(test)} //RECHECK THIS LINE
                  />
                </Link>
                <Link to="#" className="text-danger">
                  <i
                    className="mdi mdi-trash-can font-size-16 text-danger me-1"
                    style={{
                      cursor: "pointer",
                    }}
                    id="deletetooltip"
                    onClick={() => this.onClickDelete(test)}
                  />
                </Link>
              </div>
            </>
          ),
        },
      ],
    };

    this.handleEditClick = this.handleEditClick.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleEditTestClicks = this.handleEditTestClicks.bind(this);
    this.toLowerCase1 = this.toLowerCase1.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }

  toLowerCase1(str) {
    return str.toLowerCase();
  }

  componentDidMount() {
    const { tests, onGetTests } = this.props;
    if (tests && !tests.length ) {
      onGetTests();
    }
    this.setState({ tests });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { tests } = this.props;
    if (!isEmpty(tests) && size(prevProps.tests) !== size(tests)) {
      this.setState({ tests: {} });
    }
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  handleEditTestClicks = () => {
    this.setState({ test: "" });
    this.toggle();
  };

  toggleViewModal = () => {
    this.setState(prevState => ({
      viewmodal: !prevState.viewmodal,
    }));
  };

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  /* Insert,Update Delete data */

  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };

  onClickDelete = (test) => {
    this.setState({ test: test });
    this.setState({ deleteModal: true });
  };

  handleDeleteTest = () => {
    const { onDeleteTest } = this.props;
    const { test } = this.state;
    if (test.id !== undefined) {
      onDeleteTest(test);
      this.onPaginationPageChange(1);
      this.setState({ deleteModal: false });
    }
  };

  handleEditClick = arg => {
    const order = arg;
    const test =arg
    this.setState({
      test: {
        id: test.id,
        Title: test.Title,
        UpperPriceLimit: test.UpperPriceLimit,
        LowerPriceLimit: test.LowerPriceLimit,
        PreConditions: test.PreConditions,
        Description: test.Description,
        AvgDuration: test.AvgDuration,
      },
     // isEdit: true,
    });

    this.toggle();
  };

  // handleTestEditClick = () => {
  //   this.setState({ test: "" });
  //   this.toggle();
  // };

  

  render() {
    const { tests } = this.props;

    const test = this.state.test;
  

    const { SearchBar } = Search;

    const { isEdit, deleteModal } = this.state;

    
    const {onUpdateTest}=this.props;
    //const { onUpdateTest } = this.props;

    //pagination customization
    const pageOptions = {
      sizePerPage: 10,
      totalSize: tests.length, 
      custom: true,
    };

    const defaultSorted = [
      {
         dataField: "Title",
        order: "asc",
      },
    ];

    const selectRow = {
      mode: "checkbox",
    };

    return (
      <React.Fragment>
        
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteTest}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
      
       
        <div className="page-content">
        
          <Container fluid>
            
            <Breadcrumbs title="Dashboard" breadcrumbItem="Test Inventory" />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions || [])}
                      keyField="id"
                      columns={this.state.TestListColumns || []}
                      data={tests || []}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={tests}
                          columns={this.state.TestListColumns || []}
                          bootstrap4
                          search
                         
                        >
                          {toolkitProps => (
                            <React.Fragment>
                  
                              <Row className="mb-2">
                                <Col sm="8">
                                  <div className="app-search">
                                    <div className="position-relative">        
                                      <MySearchBar {...toolkitProps.searchProps} />
                                    </div>
                                  </div>
                                </Col>
                               <Col sm={2}></Col>
                                <Col sm={2}
                                className=" d-flex  justify-content-end align-items-center">
                                <div className="text-sm-end"> 
                                   <Link
                                        to="/createtest"
                                        className="btn btn-primary btn-rounded w-100  d-block d-sm-none d-lg-block"
                                        >
                                        <span className="fas fa-plus"></span>
                                        {"  "}Create Test
                                        </Link>
                                        <Link
                                        to="/createtest"
                                        className="btn btn-primary w-100 btn-sm btn-rounded d-none px-3 py-2 d-sm-block d-lg-none "
                                        >
                                        <span className="fas fa-plus" style={{ width: 20 }}></span>
                                        </Link>
                                    {/* <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={this.handleOrderClicks}
                                    >
                                      <i className="mdi mdi-plus me-1" /> Create Test
                                    </Button> */}

                                  </div>
                                 
                                </Col>
                              </Row>
                              <div className="table-responsive">
                                <BootstrapTable
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  defaultSorted={defaultSorted}
                                  bordered={false}
                                  striped={false}
                                  selectRow={selectRow}
                                  classes={
                                    "table align-middle table-nowrap table-check"
                                  }
                                  headerWrapperClasses={"table-light"}
                                  ref={this.node}
                                />
                                {/* {this.props.loading && (
              <div className="text-center " style={{

              }}>
                <i className="bx bx-loader bx-spin align-middle me-2" style={{fontSize:48,color:'#2A3042'}}/>
              </div>
            )} */}
                                <Modal
                                  isOpen={this.state.modal}
                                  className={this.props.className}
                                >
                                  <ModalHeader toggle={this.toggle} tag="h4">
                                   Edit Test
                                  </ModalHeader>
                                  <ModalBody>
                                    <Formik
                                      enableReinitialize={true}
                                      initialValues={{
                                        // id: (test && test.id) || "",
                                        Title:
                                          (test && test.Title) || "",
                                        UpperPriceLimit:
                                          (test && test.UpperPriceLimit) || "",
                                        LowerPriceLimit: (test && test.LowerPriceLimit) || "",
                                        PreConditions:
                                          (test && test.PreConditions) || "",
                                        AvgDuration:
                                          (test && test.AvgDuration) || "",
                                          Description:
                                          (test && test.Description) || "",
                                      }}
                                      validationSchema={Yup.object().shape({
                                        // id: Yup.string().required(
                                        //   "Please Enter Your test Id"
                                        // ),
                                        Title: Yup.string().required(
                                          "Please Enter Your Test Title"
                                        ),
                                        UpperPriceLimit: Yup.string().required(
                                          "Please Enter Your Upper Price"
                                        ).min(0, "LowerPriceLimit must be greater than 0"),
                                        LowerPriceLimit:
                                          Yup.string().required("Lower Price Limit").min(0, "LowerPriceLimit must be greater than 0"),
                                        PreConditions: Yup.string().required(
                                          "Please Enter Your Pre Conditions"
                                        ),
                                        AvgDuration: Yup.string().required(
                                          "Please Enter Your Average duration"
                                        ),
                                        Description: Yup.string().required(
                                          "Please Enter Your Description"
                                        ).min(100, "Description must be at least 100 characters"),
                                      })}
                                      onSubmit={values => {
                                          const updatedtest = {
                                            id: test ? test.id : 0,
                                            id: values.id,
                                            Title: values.Title,
                                            UpperPriceLimit: values.UpperPriceLimit,
                                            LowerPriceLimit: values.LowerPriceLimit,
                                            PreConditions: values.PreConditions, //needs to be changed
                                            Description: values.Description,
                                            AvgDuration: values.AvgDuration,
                                          };

                                          this.props.onUpdateTest(updatedtest, test.id);
                                          this.toggle();
                                        }}
                                         
                                      
                                    >
                                      {({ errors, status, touched }) => (
                                        <Form>
                                          <Row>
                                            <Col className="col-12">
                                             
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Test Title
                                                </Label>
                                                <Field
                                                  name="Title"
                                                  type="text"
                                                  className={
                                                    "form-control" +
                                                    (errors.Title &&
                                                      touched.Title
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                />
                                                <ErrorMessage
                                                  name="Title"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Preconditions
                                                </Label>
                                                <Field
                                                  name="PreConditions"
                                                  type="text"
                                                  className={
                                                    "form-control" +
                                                    (errors.PreConditions &&
                                                      touched.PreConditions
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                />
                                                <ErrorMessage
                                                  name="PreConditions"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Description
                                                </Label>
                                                <Field
                                                  name="Description"
                                                  type="text"
                                                  component="textarea"
                                                  rows="5"
                                                  className={
                                                    "form-control" +
                                                    (errors.Description &&
                                                      touched.Description
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                />
                                                <ErrorMessage
                                                  name="Description"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Lower Price Limit
                                                </Label>
                                                <Field
                                                  name="LowerPriceLimit"
                                                  type="number"
                                                  className={
                                                    "form-control" +
                                                    (errors.LowerPriceLimit &&
                                                      touched.LowerPriceLimit
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                >
                                                 
                                                </Field>
                                              </div>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Upper Price Limit
                                                </Label>
                                                <Field
                                                  name="UpperPriceLimit"
                                                  type="number"
                                                  className={
                                                    "form-control" +
                                                    (errors.UpperPriceLimit &&
                                                      touched.UpperPriceLimit
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                >
                                                  
                                                </Field>
                                              </div>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Average duration
                                                </Label>
                                                <Field
                                                  name="AvgDuration"
                                                  type="text"
                                                  className={
                                                    "form-control" +
                                                    (errors.AvgDuration &&
                                                      touched.AvgDuration
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                >
                                                 
                                                </Field>
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <div className="text-end">
                                                <button
                                                  type="submit"
                                                  className="btn btn-success save-user"
                                                >
                                                  Save
                                                </button>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Form>
                                      )}
                                    </Formik>
                                  </ModalBody>
                                </Modal>
                              </div>
                              <div className="pagination pagination-rounded justify-content-end mb-2">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

TestsList.propTypes = {
  className: PropTypes.any,
  tests: PropTypes.array,
  onGetTests: PropTypes.func,
  onUpdateTest: PropTypes.func,
  onDeleteTest: PropTypes.func,
  loading: PropTypes.bool,
};

const mapStateToProps = state => ({

  tests: state.TestReducer.tests,
  test: state.TestReducer.test,
  loading: state.TestReducer.isLoading,
});

const mapDispatchToProps = dispatch => ({

  onGetTests: () => dispatch(getTestsListRequest()),
  // onUpdateTest: test => dispatch(updateTestRequest(test)),
  onUpdateTest: (test, id) =>
    dispatch(updateTestRequest(test, id)),
  onDeleteTest: test => dispatch(deleteTestRequest(test)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TestsList));
